import orderBy from 'lodash.orderby'
import {
  Id,
  Identifiable,
  RowConfig,
  SortConfig
} from '@components/common/sandbox/list-view/types'

const undefinedSortBy = (): undefined => undefined

export const configuredSort = <TData extends Identifiable>(
  data: RowConfig<TData>[],
  sortConfig: SortConfig<TData>,
  asc: boolean,
  doneMap: Map<Id, boolean>
): RowConfig<TData>[] => {
  const sortBy = sortConfig.sortBy || undefinedSortBy

  /**
   * Double sorting by done and sortBy is not tested with real situations when doneMap is not empty (because it's not used yet in the project)
   * So, it's better to test it before using in lists with both done tasks and sort by column
   */
  return orderBy(
    data,
    [
      row => (doneMap.get(row.data.id) ? 1 : 0), // Сортируем по done, чтобы done задачи шли в конце
      row => {
        const sortByValue = sortBy(row.data, asc)
        return typeof sortByValue === 'string'
          ? sortByValue.toLowerCase()
          : sortByValue
      }
    ],
    ['asc', asc ? 'asc' : 'desc']
  )
}
